import React from "react";
import { useForm, Controller } from "react-hook-form";
import InputMask from "react-text-mask";

export const Contact = (props) => {
  const { register, handleSubmit, control, formState: { errors } } = useForm();

  const handleWhatsApp = (data) => {
    const { name, birthdate, height, tattooLocation, tattooSize, message } = data;

    if (!name || !birthdate || !height || !tattooLocation || !tattooSize) {
      alert("Preencha todos os campos antes de enviar via WhatsApp.");
      return;
    }

    const telefone = "5543984857775";
    const texto = `Olá! Meu nome é ${name}, nascido em ${birthdate}.\n\nAltura (cm): ${height}\n\nLocal da tatuagem: ${tattooLocation}\nTamanho aproximado (cm): ${tattooSize}\n\nDetalhes: ${message}`;
    const link = `https://wa.me/${telefone}?text=${encodeURIComponent(texto)}`;
    window.open(link, "_blank");
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Faça seu orçamento</h2>
                <p>
                  Preencha o formulário abaixo para nos enviar uma mensagem via WhatsApp.
                </p>
              </div>
              <form name="sentMessage" onSubmit={handleSubmit(handleWhatsApp)}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="name">Nome</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Nome"
                        {...register("name", { required: "Nome é obrigatório" })}
                      />
                      {errors.name && <span>{errors.name.message}</span>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="birthdate">Data de Nascimento</label>
                      <Controller
                        name="birthdate"
                        control={control}
                        rules={{ required: "Data de nascimento é obrigatória" }}
                        render={({ field }) => (
                          <InputMask
                            {...field}
                            mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                            id="birthdate"
                            className="form-control"
                            placeholder="Data de Nascimento (dd/MM/yyyy)"
                          />
                        )}
                      />
                      {errors.birthdate && <span>{errors.birthdate.message}</span>}
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="height">Altura (cm)</label>
                  <input
                    type="text"
                    id="height"
                    name="height"
                    className="form-control"
                    placeholder="Sua altura (em centímetros)"
                    {...register("height", { required: "Altura é obrigatória" })}
                  />
                  {errors.height && <span>{errors.height.message}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="tattooLocation">Local da tatuagem</label>
                  <input
                    type="text"
                    id="tattooLocation"
                    name="tattooLocation"
                    className="form-control"
                    placeholder="Ex: antebraço, costas, costela..."
                    {...register("tattooLocation", { required: "Local da tatuagem é obrigatório" })}
                  />
                  {errors.tattooLocation && <span>{errors.tattooLocation.message}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="tattooSize">Tamanho aproximado (cm)</label>
                  <input
                    type="number"
                    id="tattooSize"
                    name="tattooSize"
                    className="form-control"
                    placeholder="Tamanho aproximado (em centímetros)"
                    {...register("tattooSize", { required: "Tamanho da tatuagem é obrigatório" })}
                  />
                  {errors.tattooSize && <span>{errors.tattooSize.message}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="message">Detalhes da Tatuagem</label>
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Espaço para explicar a ideia, referências e observações"
                    {...register("message")}
                  ></textarea>
                </div>

                <div id="success"></div>
                <button
                  type="submit"
                  className="btn btn-custom-whatsapp btn-lg"
                  style={{ marginLeft: "10px" }}
                >
                  Enviar via WhatsApp
                </button>
              </form>
            </div>
          </div>

          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Informações de Contato</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Endereço
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
              <p>
                {props.data ? props.data.complemento : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Fone
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
          </div>

          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a
                      href="https://facebook.com/ricardo.henrique.18847"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://instagram.com/ricardovasconcellostattoo"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>&copy; 2025 Sergio Gabriel. All rights reserved</p>
        </div>
      </div>
    </div>
  );
};
